export default __webpack_public_path__ + "static/media/model-3.30651f79.jpg";